import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';

interface Props {
  remaining?: number;
}

export const ProgressBarCountdown = (props: Props) => (
  <CountdownRow>
    <Text weight="semibold" color={colors.neutral[50]}>
      {props.remaining || 0} to go
    </Text>
  </CountdownRow>
);

export const ProgressBarCompletedMessage = () => (
  <FinishedRow>
    <FontAwesomeIcon icon="check-circle" color={colors.success[60]} />
    <Text weight="semibold" color={colors.success[60]}>
      Well done!
    </Text>
  </FinishedRow>
);

const CountdownRow = styled.View`
  flex-direction: row;
  justify-content: flex-end;
`;

const FinishedRow = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
